import { FindKeiyakushaResult } from "~/api/data/Admin/Keiyakusha/FindKeiyakushaResult";
export class KeiyakushaListViewModel {
    constructor(model) {
        this.model = model;
    }
    model = new FindKeiyakushaResult();
    get userCd() {
        return this.model.userCd;
    }
    get userName() {
        return this.model.userName;
    }
    get userKb() {
        return this.model.userKb;
    }
    get buknCd() {
        return this.model.buknCd;
    }
    get buknName() {
        return this.model.buknName;
    }
    get roomNo() {
        return this.model.roomNo;
    }
    get email() {
        return this.model.email;
    }
    get kankatsuKb() {
        return this.model.kankatsuKb;
    }
    get loginId() {
        return this.model.loginId;
    }
}
